import { ContentIcon } from '@app/components/icons/content-icon';
import { FLAG_ENABLE_CONTENT_LIBRARY_ORG_DASHBOARD } from '@app/features/analytics/constants';
import { FLAG_CHANGE_CONTENT_LIBRARY_DEFAULT_TAB } from '@app/utilities/flags';
import type { TFunction } from '@hopin-team/dashboard-shared-react';
import type { IconProp } from '@hopin-team/ui-icon';
import { LDFlagSet } from 'launchdarkly-js-client-sdk';
import React, { ReactNode } from 'react';

import { New } from '../new-badge';
import { Crown } from './crown';

export type NavTypes = 'organization' | 'attendee';
export type MenuItem = {
  name: string;
  label: string;
  icon?: IconProp;
  customIcon?: ReactNode;
  link?: string;
  onCLick?: () => void;
  href?: string;
  openInNewTab?: boolean;
  iconSuffix?: ReactNode;
  disabled?: boolean;
  activePath?: string | string[];
};

export type MenuItems = {
  menuItems: MenuItem[];
  additionalMenuItems: MenuItem[];
};

export const getMenuItems = ({
  organizationSlug,
  features,
  isFreePlan,
  flags,
  t,
}: {
  organizationSlug?: string;
  t: TFunction<'translation', undefined>;
  features?: { appStore: boolean };
  isFreePlan: boolean;
  flags?: LDFlagSet;
}): MenuItems => {
  if (organizationSlug) {
    return {
      menuItems: [
        {
          name: 'home',
          icon: 'house',
          label: t('navbar.home'),
          link: `/org/${organizationSlug}/events`,
          activePath: [
            `/org/${organizationSlug}/events`,
            `/org/${organizationSlug}/series`,
          ],
        },
        {
          name: 'analytics',
          icon: 'chart-bar-two-tone',
          label: t('navbar.analytics'),
          link: `/org/${organizationSlug}/analytics`,
          iconSuffix: isFreePlan ? <Crown /> : undefined,
        },
        {
          name: 'Content',
          customIcon: <ContentIcon className="w-4 h-4" />,
          label: t('navbar.content'),
          link: `/org/${organizationSlug}/content/${
            flags?.[FLAG_ENABLE_CONTENT_LIBRARY_ORG_DASHBOARD] &&
            flags?.[FLAG_CHANGE_CONTENT_LIBRARY_DEFAULT_TAB]
              ? 'library'
              : 'hubs'
          }`,
          activePath: `/org/${organizationSlug}/content`,
          iconSuffix: <New />,
        },
        {
          name: 'apps',
          icon: 'bolt',
          label: t('navbar.apps'),
          link: `/org/${organizationSlug}/apps`,
          iconSuffix: features?.appStore === false ? <Crown /> : undefined,
        },
      ],
      additionalMenuItems: [],
    };
  }
  // else return attendee nav
  return {
    menuItems: [
      {
        name: 'home',
        icon: 'house',
        label: t('navbar.home'),
        link: '/attendee',
      },
      {
        name: 'connections',
        icon: 'users' as IconProp,
        label: t('navbar.connections'),
        link: `/connections`,
      },
    ],
    additionalMenuItems: [],
  };
};
